import {
  SET_TITLE,
  SET_BACK_ROUTE,
  ASYNC_REQUEST,
  ASYNC_SUCCESS,
  ASYNC_FAILURE,
  SET_THEME
} from '../mutation-types'

// initial state
const state = {
  title: '',
  isLoading: false,
  backRoute: {
    name: 'root'
  },
  theme: 'standard'
}

// mutations
const mutations = {
  [SET_TITLE] (state, title) {
    state.title = title
  },
  [SET_THEME] (state, theme) {
    document.body.classList.remove(`theme-${state.theme}`)
    state.theme = theme
    document.body.classList.add(`theme-${state.theme}`)
  },
  [SET_BACK_ROUTE] (state, name) {
    state.backRoute.name = name
  },
  [ASYNC_REQUEST] (state) {
    state.isLoading = true
  },
  [ASYNC_SUCCESS] (state) {
    state.isLoading = false
  },
  [ASYNC_FAILURE] (state, error) {
    state.isLoading = false
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/view/store.js